import uniqBy from "lodash/uniqBy";

import {getCommonVisualizerType} from "../../config";
import {getLookList} from "../look/lookNavigation/lookFunctions";
import {getCurrentLayout} from "../appLayout";

export const saveButtonIsEnabled = (popupContext) => {
  return !!popupContext.userFile && popupContext.promptsList && popupContext.promptsList.some(pr => pr.isActive);
}

export const imageIsRenderedAndUserIsNotLoggedIn = (showLeadOverlay, aiResults) => {
  return showLeadOverlay && aiResults.some(res => res.resultImageUrl);
}

export const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => {
    const dataUrl = reader.result;
    const base64Data = dataUrl.split(',')[1]; // ← This extracts just the image part
    resolve(base64Data);
  };
  reader.onerror = reject;
});

export const getExportAIData = (aiState, groupObjects, aiResults) => {
  const visualizerType = getCommonVisualizerType();
  let exportData = {
    ...aiState.aiExportData,
    aiResults: (aiResults || aiState.aiResults).map(result => {
      if (result.sourceImageUrl?.includes("base64")) {
        result.sourceImageUrl = ""
      }
      return {
        conversionError: result.conversionError,
        sourceImageUrl: result.sourceImageUrl,
        resultImageUrl: result.resultImageUrl,
        id: result.id,
        isActive: result.isActive,
      };
    })
  };
  if (Array.isArray(groupObjects) && groupObjects.length > 0) {
    exportData.aiGroups = {
      ...(exportData.aiGroups || {}),
      [visualizerType]: (groupObjects || []).map(groupObject => {
        return {
          partId: groupObject.partId,
          enabled: groupObject.enabled,
          groupName: groupObject.groupName || groupObject.featureGroup?.dbName || groupObject.featureGroup?.partName,
        }
      })
    }
  }
  // console.log("exportData", exportData);
  return exportData
}

export const hideGroupObject = (groupObject, showAllGroups = false) => {
  if (showAllGroups) {
    return !groupObject
  }
  return !groupObject
    || groupObject.hideIfShowAllIsNotEnabled
    || !groupObject.featureGroup
    || (groupObject.featureGroup.hideLayerCondition && groupObject.featureGroup.hideLayerCondition())
    || (groupObject.featureGroup.activeFeature && !groupObject.featureGroup.activeFeature.layer.src)
}

export const getAIInitialGroups = (aiImportData, aiSettings, forDevSettings = false) => {
  const lookList = getLookList();
  const layout = getCurrentLayout();
  const visualizerType = getCommonVisualizerType();

  const aiGroups = aiImportData && aiImportData.aiGroups && aiImportData.aiGroups[visualizerType] && aiImportData.aiGroups[visualizerType].length
    ? aiImportData.aiGroups[visualizerType]
    : Array.isArray(aiSettings.aiGroups)
      ? aiSettings.aiGroups
      : typeof aiSettings.aiGroups === "object" ? aiSettings.aiGroups[visualizerType] || [] : [];
  const groupsList = aiGroups.length ? aiGroups.map(group => {
    if (typeof group === "object") {
      const featureGroup = layout.getFeatureGroupByGroupName(group.groupName);
      if (featureGroup) {
        return {
          ...group,
          featureGroup,
        }
      }
    }
    const featureGroup = layout.getFeatureGroupByGroupName(group);
    if (featureGroup) {
      return {
        featureGroup,
        partId: featureGroup.partId,
      }
    }
  }).filter(groupName => groupName) : lookList;

  if (forDevSettings) {
    const allFetureGroups = layout.getAllFeatureGroups();
    return allFetureGroups.map(featureGroup => {
      return {
        featureGroup,
        partId: featureGroup.partId,
        enabled: true,
        hideIfShowAllIsNotEnabled: !groupsList.some(group => group.partId === featureGroup.partId),
      }
    })
  }

  return uniqBy(groupsList, (item) => item.partId)
    .filter(groupObject => groupObject?.featureGroup?.activeFeature)
    .map(groupObject => {
      groupObject.enabled = forDevSettings
        ? true
        : typeof groupObject.enabled === 'boolean' ? groupObject.enabled : true;
      return groupObject
    });
}
